import React from 'react';

const About = () => {
  return (
    <div className="bg-light">
      {/* Hero Section */}
      <div style={{ background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)', color: 'white', padding: '80px 0' }}>
        <div className="container text-center">
          <h1 className="display-3 fw-bold mb-4" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>About Nakshatra Infra Projects</h1>
          <p className="lead" style={{ fontSize: '1.5rem', opacity: 0.9 }}>Building Dreams, Creating Legacies</p>
          
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5">

        {/* Company Overview */}
        <section className="mb-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2 className="h1 font-weight-bold text-dark mb-4" style={{ color: '#2180CE' }}>Who We Are</h2>
              <p className="lead text-muted fw-bold mb-4">
Our company is engaged in developing top-notch Real Estate projects in Hyderabad and has many successful projects under its banner. We aim to provide a comprehensive service by applying time and local knowledge while taking care to ensure all clients are treated with respect and professionalism.              </p>
              <p className="lead fw-bold text-muted">
Our experience and efficiency allows us to respond to changing market conditions and implement developments across a wide range of product types, quickly and effectively

We love talking about real estate and connecting with people from all walks of life.We would invite you to drop in, speak to our team and see what all we have to offer.              </p>
            </div>
            <div className="col-lg-6">
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop" alt="Hyderabad Skyline" className="img-fluid rounded shadow" />
            </div>
          </div>
        </section>

        {/* Vision & Mission */}
        <section className="mb-5">
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                <div className="card-body p-4">
                  <div className="text-center mb-3">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                      👁️
                    </div>
                  </div>
                  <h3 className="h4 font-weight-bold text-center mb-3" style={{ color: '#2180CE' }}>Our Vision</h3>
                  <p className="text-muted text-center">
                    To emerge as Hyderabad's most trusted and respected real estate developer, recognized for delivering projects that combine innovation, sustainability, and exceptional value. We envision creating communities where families thrive and investments flourish for generations to come.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                <div className="card-body p-4">
                  <div className="text-center mb-3">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                      🎯
                    </div>
                  </div>
                  <h3 className="h4 font-weight-bold text-center mb-3" style={{ color: '#2180CE' }}>Our Mission</h3>
                  <p className="text-muted text-center">
                    To provide comprehensive real estate solutions with unwavering commitment to legal compliance, quality construction, and customer-centric service. We strive to make property ownership accessible, transparent, and rewarding through HMDA and RERA approved projects with seamless bank loan facilitation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="mb-5">
          <h2 className="h1 font-weight-bold text-center text-dark mb-5" style={{ color: '#2180CE' }}>Our Core Values</h2>
          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px', backgroundColor: '#2180CE', color: 'white', fontSize: '2rem' }}>
                    ✓
                  </div>
                  <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Integrity</h4>
                  <p className="text-muted">We conduct business with honesty and maintain the highest ethical standards in all our dealings.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '2rem' }}>
                    👥
                  </div>
                  <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Customer Focus</h4>
                  <p className="text-muted">Our customers are at the heart of everything we do, and their satisfaction drives our success.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px', backgroundColor: '#2180CE', color: 'white', fontSize: '2rem' }}>
                    ⭐
                  </div>
                  <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Excellence</h4>
                  <p className="text-muted">We pursue excellence in every project, ensuring superior quality and timely delivery.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Legal Approvals */}
        <section className="mb-5 py-5" style={{ backgroundColor: '#f8f9fa' }}>
          <div className="container">
            <h2 className="h1 font-weight-bold text-center text-dark mb-4" style={{ color: '#2180CE' }}>Legal Approvals & Certifications</h2>
            <p className="lead text-muted text-center mb-5">
              All our projects are developed in strict compliance with government regulations and approved by the relevant authorities. We believe in complete transparency and ensure that every customer receives proper documentation.
            </p>
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow-lg text-center" style={{ background: 'white', borderRadius: '15px' }}>
                  <div className="card-body p-4">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '70px', height: '70px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                      🏛️
                    </div>
                    <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>HMDA Approved</h4>
                    <p className="text-muted">Hyderabad Metropolitan Development Authority approval ensures proper planning and layout as per urban development norms.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow-lg text-center" style={{ background: 'white', borderRadius: '15px' }}>
                  <div className="card-body p-4">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '70px', height: '70px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                      📋
                    </div>
                    <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>RERA Registered</h4>
                    <p className="text-muted">Real Estate Regulatory Authority registration guarantees project transparency and protects customer interests.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow-lg text-center" style={{ background: 'white', borderRadius: '15px' }}>
                  <div className="card-body p-4">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '70px', height: '70px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                      💳
                    </div>
                    <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Bank Loan Facilitation</h4>
                    <p className="text-muted">Tie-ups with leading banks enable easy home loan processing and flexible financing options for customers.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="mb-5">
          <h2 className="h1 font-weight-bold text-center text-dark mb-5" style={{ color: '#2180CE' }}>Why Choose Nakshatra Infra Projects</h2>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold text-white" style={{ width: '50px', height: '50px', backgroundColor: '#FFBE1D', fontSize: '1.2rem' }}>1</div>
                </div>
                <div>
                  <h4 className="h5 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Proven Track Record</h4>
                  <p className="text-muted">Years of successful project completions and thousands of satisfied customers across Hyderabad testify to our reliability and commitment to quality.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold text-white" style={{ width: '50px', height: '50px', backgroundColor: '#FFBE1D', fontSize: '1.2rem' }}>2</div>
                </div>
                <div>
                  <h4 className="h5 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Strategic Locations</h4>
                  <p className="text-muted">Our properties are strategically located in high-growth corridors with excellent connectivity to IT hubs, educational institutions, hospitals, and commercial centers.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold text-white" style={{ width: '50px', height: '50px', backgroundColor: '#FFBE1D', fontSize: '1.2rem' }}>3</div>
                </div>
                <div>
                  <h4 className="h5 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Complete Transparency</h4>
                  <p className="text-muted">We believe in honest communication with clear pricing, no hidden charges, and complete disclosure of all project details and legal documentation.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold text-white" style={{ width: '50px', height: '50px', backgroundColor: '#FFBE1D', fontSize: '1.2rem' }}>4</div>
                </div>
                <div>
                  <h4 className="h5 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Premium Infrastructure</h4>
                  <p className="text-muted">Wide black-topped roads, underground drainage, street lighting, landscaped parks, and modern amenities make our projects stand out.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold text-white" style={{ width: '50px', height: '50px', backgroundColor: '#FFBE1D', fontSize: '1.2rem' }}>5</div>
                </div>
                <div>
                  <h4 className="h5 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Customer Support</h4>
                  <p className="text-muted">Our dedicated customer service team provides end-to-end assistance from site selection to registration, ensuring a hassle-free buying experience.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center font-weight-bold text-white" style={{ width: '50px', height: '50px', backgroundColor: '#FFBE1D', fontSize: '1.2rem' }}>6</div>
                </div>
                <div>
                  <h4 className="h5 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Investment Value</h4>
                  <p className="text-muted">Our projects are designed to appreciate over time, making them not just homes but valuable long-term investments for your family's future.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Commitment Statement */}
        <section style={{ background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)', color: 'white', padding: '60px 0', borderRadius: '15px' }}>
          <div className="container text-center">
            <h2 className="h1 font-weight-bold mb-4">Our Commitment to You</h2>
            <p className="lead mb-4" style={{ maxWidth: '800px', margin: '0 auto', opacity: 0.9 }}>
              At Nakshatra Infra Projects, we don't just build properties; we build relationships based on trust. Every plot, every project, and every interaction reflects our dedication to excellence. We promise to deliver not just land, but a foundation for your dreams, backed by legal certainty and unwavering support throughout your journey with us.
            </p>
            <div className="mt-4">
              <button className="btn btn-light btn-lg mr-3" style={{ backgroundColor: 'white', color: '#2180CE', border: 'none', padding: '15px 30px', borderRadius: '30px', fontWeight: 'bold' }}>
                Contact Us Today
              </button>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default About;